<template>
  <div class="w-full overflow-x-scroll">
    <table>
      <thead>
        <tr>
          <th>Order</th>
          <th>Channel</th>
          <th>Moderators</th>
          <th>Locked</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <channel-row
          v-for="channel in channels"
          :key="channel.slug"
          :category="category"
          :channel="channel"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import ChannelRow from "./ChannelRow"
import { find } from "lodash"
import { mapGetters } from "vuex"

export default {
  name: "ChannelTable",
  components: {
    ChannelRow
  },
  props: {
    category: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      categories: "categories/list"
    }),
    channels() {
      let category = find(this.categories, ["slug", this.category.slug])
      return category.channels
    }
  }
}
</script>
